/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { getPassImage } from 'shared-ui/utils/pass-images';

export default function PassImages({ type }) {
    const passTypeMap = {
        INTERAGENCY_ANNUAL_PASS: 'annual',
        INTERAGENCY_ANNUAL_SENIOR_PASS: 'senior-annual',
        INTERAGENCY_LIFETIME_SENIOR_PASS: 'senior-lifetime',
        INTERAGENCY_ACCESS_PASS: 'access',
        INTERAGENCY_VOLUNTEER_PASS: 'volunteer',
        INTERAGENCY_MILITARY_PASS: 'military-annual',
        INTERAGENCY_LIFETIME_MILITARY_PASS: 'military-lifetime',
        INTERAGENCY_FOURTH_GRADE_PASS: 'fourth-grade',
        INTERAGENCY_RESIDENT_PASS: 'resident',
        INTERAGENCY_NONRESIDENT_PASS: 'nonresident',
        GOLDEN_AGE_PASS: 'golden-age',
        GOLDEN_ACCESS_PASS: 'golden-access',
    };

    const passNameMap = {
        INTERAGENCY_ANNUAL_PASS: 'America the Beautiful Annual Pass',
        INTERAGENCY_ANNUAL_SENIOR_PASS: 'America the Beautiful Annual Senior Pass',
        INTERAGENCY_LIFETIME_SENIOR_PASS: 'America the Beautiful Lifetime Senior Pass',
        INTERAGENCY_ACCESS_PASS: 'America the Beautiful Access Pass',
        INTERAGENCY_VOLUNTEER_PASS: 'America the Beautiful Volunteer Pass',
        INTERAGENCY_MILITARY_PASS: 'America the Beautiful Military Pass',
        INTERAGENCY_LIFETIME_MILITARY_PASS:
            'America the Beautiful Lifetime Military Pass',
        INTERAGENCY_FOURTH_GRADE_PASS: 'America the Beautiful Fourth Grade Pass',
        INTERAGENCY_RESIDENT_PASS: 'America the Beautiful Resident Annual Pass',
        INTERAGENCY_NONRESIDENT_PASS: 'America the Beautiful Non-Resident Annual Pass',
        GOLDEN_AGE_PASS: 'Golden Age Pass',
        GOLDEN_ACCESS_PASS: 'Golden Access Pass',
    };

    const mappedType = passTypeMap[type];

    if (!mappedType) {
        return null;
    }

    const imageSrc = getPassImage({
        passType: mappedType,
        variant: { type: 'sized', size: 'sm' },
    });

    return (
        <div className="te-pass-images">
            <img
                src={imageSrc}
                alt={passNameMap[type] || 'Example America the Beautiful pass'}
            />
        </div>
    );
}

PassImages.propTypes = {
    type: PropTypes.string,
};
